import React from 'react';
import { Switch, FormControlLabel, FormGroup, Typography } from '@mui/material';
import './ViewToggle.css';

interface ViewToggleProps {
  showDetailedSteps: boolean;
  onToggleDetailedSteps: () => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ 
  showDetailedSteps, 
  onToggleDetailedSteps 
}) => {
  return (
    <div className="view-toggle">
      <FormGroup>
        <div className="toggle-container">
          <Typography variant="body2" className="toggle-label">
            View Mode:
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={showDetailedSteps}
                onChange={onToggleDetailedSteps}
                color="primary"
              />
            }
            label={
              <Typography variant="body2" className="toggle-text">
                {showDetailedSteps ? 'Detailed Steps' : 'Phases Only'}
              </Typography>
            }
          />
        </div>
      </FormGroup>
    </div>
  );
};

export default ViewToggle; 